import type { driverType } from './src/interfaces'
import StorageWithEvents from './src/storageWithEvents'
const STORAGE_PREFIX = 'ot-'
const LOCAL_STORAGE: driverType = 'local'
const SESSION_STORAGE: driverType = 'session'

const localStorage = new StorageWithEvents(STORAGE_PREFIX, LOCAL_STORAGE)
const sessionStorage = new StorageWithEvents(STORAGE_PREFIX, SESSION_STORAGE)

export { localStorage, sessionStorage }
